"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var borderTransparent = exports.borderTransparent = "1px solid transparent";
var borderGray100 = exports.borderGray100 = "1px solid $color-gray-100";
var borderGray200 = exports.borderGray200 = "1px solid $color-gray-200";
var borderGray300 = exports.borderGray300 = "1px solid $color-gray-300";
var borderGray400 = exports.borderGray400 = "1px solid $color-gray-400";
var borderGray700 = exports.borderGray700 = "1px solid $color-gray-700";
var borderPrimaryMedium = exports.borderPrimaryMedium = "1px solid $color-primary-medium";
var borderPrimaryDark = exports.borderPrimaryDark = "1px solid $color-primary-dark";
var borderPrimaryActive = exports.borderPrimaryActive = "1px solid $color-primary-focus";
var borderPrimaryFocus = exports.borderPrimaryFocus = "2px solid $color-primary-focus";
var borderError600 = exports.borderError600 = "1px solid $color-error-600";
var borderError700 = exports.borderError700 = "1px solid $color-error-700";
var borderError800 = exports.borderError800 = "1px solid $color-error-800";
var borderError900 = exports.borderError900 = "1px solid $color-error-900";
var borderSuccess500 = exports.borderSuccess500 = "1px solid $color-success-500";
var borderWarning500 = exports.borderWarning500 = "1px solid $color-warning-500";
var borderRadiusDefault = exports.borderRadiusDefault = "3px";
var borderRadiusSmall = exports.borderRadiusSmall = "1px";
var borderRadiusCurve = exports.borderRadiusCurve = "10em 5em";
var boxShadowSoft = exports.boxShadowSoft = "0 2px 4px 0 rgba(19, 21, 23, 0.3)";
var boxShadowSoftOverlay = exports.boxShadowSoftOverlay = "0 4px 8px 0 rgba(19, 21, 23, 0.6)";
var boxShadowSoftSelected = exports.boxShadowSoftSelected = "0 1px 3px 0 rgba(7, 48, 92, 0.5)";
var boxShadowHard = exports.boxShadowHard = "0 1px 0 0 rgba(181, 185, 189, 1)";
var boxShadowHardHover = exports.boxShadowHardHover = "0 1px 3px 0 rgba(97, 99, 101, 1)";
var boxShadowHardFocus = exports.boxShadowHardFocus = "0 1px 0 0 rgba(0, 149, 255, 1)";
var boxShadowHardSelected = exports.boxShadowHardSelected = "0 1px 0 0 rgba(7, 48, 92, 0.5)";
var boxShadowInsetDark = exports.boxShadowInsetDark = "inset 0 2px 3px 1px rgba(19, 21, 23, 0.6)";
var boxShadowInsetLight = exports.boxShadowInsetLight = "inset 0 2px 3px 1px rgba(19, 21, 23, 0.3)";
var boxShadowAbove = exports.boxShadowAbove = "0 2px 4px 0 rgba(19, 21, 23, 0.10)";
var boxShadowBelow = exports.boxShadowBelow = "0 -2px 4px 0 rgba(19, 21, 23, 0.10)";
var boxShadowFocus = exports.boxShadowFocus = "0 0 0 2px $color-primary-focus";
var boxShadowFocusWrap = exports.boxShadowFocusWrap = "0 0 0 1px $color-primary-focus";
var boxShadowPrimary = exports.boxShadowPrimary = "inset 0 2em 1.8em -1em $color-primary-selection-a70";
var boxShadowPrimaryHover = exports.boxShadowPrimaryHover = "inset 0 1em 1em -1em $color-primary-selection-a70";
var backgroundPrimary = exports.backgroundPrimary = "$color-primary-medium";
var boxShadowNeutral = exports.boxShadowNeutral = "inset 0 -2em 1.8em -1em $color-gray-100";
var boxShadowNeutralHover = exports.boxShadowNeutralHover = "inset 0 -1em 1em -1em $color-gray-100";
var backgroundNeutral = exports.backgroundNeutral = "$color-white";
var boxShadowError = exports.boxShadowError = "inset 0 2em 1.8em -1em $color-error-600";
var boxShadowErrorHover = exports.boxShadowErrorHover = "inset 0 1em 1em -1em $color-error-600";
var backgroundError = exports.backgroundError = "$color-error-700";
var boxShadowNeutralAffix = exports.boxShadowNeutralAffix = "inset 0 2em 1.8em -1em $color-gray-50";
var boxShadowNeutralAffixHover = exports.boxShadowNeutralAffixHover = "inset 0 1em 1em -1em $color-gray-50";
var backgroundNeutralAffix = exports.backgroundNeutralAffix = "$color-gray-200";
var gradientSuccess = exports.gradientSuccess = "linear-gradient(-180deg, $color-success-500, $color-success-600)";
var gradientWarning = exports.gradientWarning = "linear-gradient(-180deg, $color-warning-500, $color-warning-700)";
var gradientError = exports.gradientError = "linear-gradient(-180deg, $color-error-600, $color-error-700)";
var gradientInfo = exports.gradientInfo = "linear-gradient(-180deg, $color-info-600, $color-info-700)";
var gradientChrome = exports.gradientChrome = "linear-gradient(-180deg, $color-gray-50, $color-gray-300)";